import React from "react";
import { ErrorAlert } from "theme/components/molecules/Alert";
import SubscribeToInStockAlert from "theme/modules/SubscribeToInStockAlert";

const OutOfStock = ({ message, unavailableLabel, sku }) => {
  return (
    <>
      <div className="add-to-cart add-to-cart--out-of-stock">
        {message && <ErrorAlert>{message}</ErrorAlert>}
        {unavailableLabel}
        <link itemProp="availability" href="http://schema.org/OutOfStock" />
      </div>
      <SubscribeToInStockAlert sku={sku} />
    </>
  );
};

export default OutOfStock;
